import React from 'react';
import { BackTop } from 'antd';
import { FormattedMessage } from 'react-intl';
import CardLayout from '../../layouts/CardLayout';
import Faq from '../../components/Faq';
import { useFaqs } from '../../assets/faqs';
import TrackView from '../../components/Onetrack/TrackView';

const FaqPage: React.FC = () => {
  const dataSource = useFaqs();
  return (
    <TrackView tip="71.2.0.1.2153">
      <CardLayout title={<FormattedMessage id="FAQ" />}>
        <Faq dataSource={dataSource} anchor />
        <BackTop visibilityHeight={200} />
      </CardLayout>
    </TrackView>
  );
};

export default FaqPage;
